// action - state management
import { REGISTER, LOGIN, LOGOUT, SETORGANIZATION } from './actions';

// types
import { AuthProps, AuthActionProps } from 'types/auth';

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  permission: null,
  organization: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const payload = action.payload!;
      return {
        ...state,
        ...(payload.isLoggedIn !== undefined && { isLoggedIn: payload.isLoggedIn }),
        ...(payload.isInitialized !== undefined && { isInitialized: payload.isInitialized }),
        ...(payload.user !== undefined && { user: payload.user }),
        ...(payload.organization !== undefined && { organization: payload.organization }),
        ...(payload.permission !== undefined && { permission: payload.permission })
      };
    }
    case SETORGANIZATION: {
      return {
        ...state,
        organization: action?.payload?.organization
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        organization: null,
        permission: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
